import type { TFunction } from 'i18next'

import type { TrpcReactUtilsClient } from '@mntn-dev/app-common'
import {
  type EmailAddress,
  EmailAddressSchema,
  type Name,
  NameSchema,
} from '@mntn-dev/domain-types'

export const UniqueUserEmailAddressSchemaBuilder = ({
  t,
  trpcClient,
  field,
  ignoreEmail,
}: {
  t: TFunction<['validation']>
  trpcClient: TrpcReactUtilsClient
  field: string
  ignoreEmail?: EmailAddress
}) => {
  return EmailAddressSchema.refine(
    async (value) => {
      return (
        value === ignoreEmail ||
        (EmailAddressSchema.safeParse(value).success &&
          !(await trpcClient.public.userEmailExists.query(value)))
      )
    },
    {
      message: t('validation:field.field-in-use', {
        field,
      }),
    }
  )
}

export const UniqueOrganizationNameSchemaBuilder = ({
  t,
  trpcClient,
  field,
  ignoreName,
}: {
  t: TFunction<['validation']>
  trpcClient: TrpcReactUtilsClient
  field: string
  ignoreName?: Name
}) => {
  return NameSchema.refine(
    async (value) => {
      return (
        value === ignoreName ||
        (NameSchema.safeParse(value).success &&
          !(await trpcClient.public.organizationNameExists.query(value)))
      )
    },
    {
      message: t('validation:field.field-in-use', {
        field,
      }),
    }
  )
}

export const UniqueTeamNameSchemaBuilder = ({
  t,
  trpcClient,
  field,
  ignoreName,
}: {
  t: TFunction<['validation']>
  trpcClient: TrpcReactUtilsClient
  field: string
  ignoreName?: Name
}) => {
  return NameSchema.refine(
    async (value) => {
      return (
        value === ignoreName ||
        (NameSchema.safeParse(value).success &&
          !(await trpcClient.public.teamNameExists.query(value)))
      )
    },
    {
      message: t('validation:field.field-in-use', {
        field,
      }),
    }
  )
}
